import React, { useContext, useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { EntryContext } from '../../contexts/entryContext';
import DisplayContent from '../../utils/DisplayContent';

const Layout = () => {
    const navigate = useNavigate();
    const { entry, game, siteAssets, igrGameUrl, setIgrGameUrl } = useContext(EntryContext);

    useEffect(() => {
        // Prevent players to use the back button to return to the game site and pages after playing the IGR game
        if (!entry) {
            setIgrGameUrl(null);
            navigate(`/`, { replace: true });
            return;
        }
    }, [igrGameUrl, entry, setIgrGameUrl, navigate]);

    return (
        <div className='container' style={{ backgroundImage: `url(${siteAssets?.backgroundImage?.ref})` }}>
            <header>
                <DisplayContent note='Lottery logo is optional' isVisible={siteAssets?.lotteryLogo?.ref}>
                    <div className='logo'>
                        <img src={siteAssets?.lotteryLogo?.ref} alt={siteAssets?.lotteryLogo?.alt} className='logo-img' />
                    </div>
                </DisplayContent>
            </header>
            <section className='main'>
                <Outlet />
            </section>
            <DisplayContent note='Game related custom CSS overrides' isVisible={game?.styleOverrides?.length}>
                <style data-testid={'css-block-custom-game'} dangerouslySetInnerHTML={{ __html: String(game?.styleOverrides) }} />
            </DisplayContent>
            <DisplayContent note='Lottery Branding CSS' isVisible={siteAssets?.styling?.lotteryBranding?.length}>
                <style data-testid={'css-block-lottery-branding'} dangerouslySetInnerHTML={{ __html: String(siteAssets?.styling?.lotteryBranding) }} />
            </DisplayContent>
        </div>
    );
};

export default Layout;
